@if (isVisible()) {
  <section
    class="share-link-banner"
    [attr.aria-label]="'landing-page.share-link.heading' | translate"
    data-testid="share-link-banner"
  >
    <div novaBannerContainer class="share-link-banner__container">
      <div novaBanner [variant]="'info'">
        <div novaBannerLeftSection>
          <nova-icon
            name="info"
            additionalClasses="nova-banner__icon"
          ></nova-icon>
        </div>
        <div novaBannerBody>
          <div novaBannerContent>
            <p novaBannerTitle>{{ 'landing-page.share-link.heading' | translate }}</p>
            <p novaBannerSubtext>{{ 'landing-page.share-link.description' | translate }}</p>
          </div>
          <div novaBannerActions class="share-link-banner__actions">
            <button
              novaButton
              appTrackedButton
              class="share-link-banner__button"
              variant="blue"
              size="small"
              data-testid="share-link-button"
              [trackId]="'landing-page:share-link'"
              [trackType]="canShare() ? 'other' : 'copy'"
              [attr.aria-label]="(canShare()
                ? 'landing-page.share-link.share-button'
                : 'landing-page.share-link.copy-button') | translate"
              (click)="onShareOrCopy()"
            >
              <nova-icon name="link" aria-hidden="true"></nova-icon>
              @if (copied()) {
                {{ 'landing-page.share-link.copy-success' | translate }}
              } @else if (canShare()) {
                {{ 'landing-page.share-link.share-button' | translate }}
              } @else {
                {{ 'landing-page.share-link.copy-button' | translate }}
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
}
